// extracted by mini-css-extract-plugin
export default {"wrapper":"GalleryTicker_wrapper__Apgmm","track":"GalleryTicker_track__Yj--O","slide":"GalleryTicker_slide__HaxKU","img":"GalleryTicker_img__Ot7ne"};